import { gql } from '@apollo/client';

import { CAREER_PROFILE_FIELDS } from '../fragments/careerProfile';

/**
 * Career profile — the structured profile that drives the CV (spec 0018, increment B).
 *
 * Replaces the old `resumes` GraphQL surface (removed from the schema).
 * `myCareerProfile` is created on first read and is open to ANY student
 * (self-only) — the profile is universal; only the training/vacancy parts are
 * member-gated (spec 0018 §6).
 *
 * Operation names are deliberately distinct from the backend field names
 * (`MyCareerProfile` vs `myCareerProfile`, `CareerSkillsSearch` vs `careerSkills`)
 * — equal names make codegen collapse the generated result type (graphql-codegen
 * skill).
 */
export const MyCareerProfileQuery = gql`
  ${CAREER_PROFILE_FIELDS}
  query MyCareerProfile {
    myCareerProfile {
      ...CareerProfileFields
    }
  }
`;

/**
 * Dictionary autocomplete for the skills / project-technologies pickers.
 * `search`/`category` are optional server-side filters.
 */
export const CareerSkillsSearchQuery = gql`
  query CareerSkillsSearch($search: String, $category: String) {
    careerSkills(search: $search, category: $category) {
      id
      name
      slug
      iconUrl
      category
    }
  }
`;
